import request from '@/utils/request'

export function getList(params = {}) {
  return request({
    url: '/tags/platformTags/index',
    method: 'get',
    params
  })
}

export function addPlatformLabel(data = {}) {
  return request({
    url: '/tags/platformTags/add',
    method: 'post',
    data
  })
}

// 书城筛选项
export function getPlatform() {
  return request({
    url: '/bookPlatform/list',
    method: 'get'
  })
}

// 获取老号绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/sdOfficialAccount/index`,
    method: 'get',
    params
  })
}
// 添加老号绑定关系
export function addBindingRelation(data = {}) {
  return request({
    url: `/sdOfficialAccount/store`,
    method: 'post',
    data
  })
}

// 修改老号绑定关系
export function modifyBindingRelation(data = {}) {
  return request({
    url: `/sdOfficialAccount/update`,
    method: 'post',
    data
  })
}

// 删除老号绑定关系
export function deleteBindingRelationp(id) {
  return request({
    url: `/sdOfficialAccount/destroy?id=${id}`,
    method: 'post'
  })
}

// 书籍筛选列表
export function getNovelList(params = {}) {
  return request({
    url: `/novel/list`,
    method: 'get',
    params
  })
}

// 公众号列表
export function getOfficialAccount(params = {}) {
  return request({
    url: `/officialAccount/list`,
    method: 'get',
    params
  })
}

// 报表数据
export function getReportList(params = {}) {
  return request({
    url: `/sdReportForm/index`,
    method: 'get',
    params
  })
}

// 更新成本
export function updateCost(data = {}) {
  return request({
    url: `/sdReportForm/updateCost`,
    method: 'post',
    data
  })
}

// 指定更新
export function theUpdata(data = {}) {
  return request({
    url: `/sdReportForm/customGenerate`,
    method: 'post',
    data
  })
}

// 获取可选管理组
export function groupList(data = {}) {
  return request({
    url: 'common/homologousGroups',
    method: 'get',
    data
  })
}

// 获取可选管理员
export function adminList(params = {}) {
  return request({
    url: `/common/homologousAdmins`,
    method: 'get',
    params
  })
}

// 导入报表成本
export function reportCost(data = {}) {
  return request({
    url: `/sdReportForm/importCost`,
    method: 'post',
    data
  })
}

// 新增投手组
export function addPitcherGroup(data = {}) {
  return request({
    url: `/sdLaunch/store`,
    method: 'post',
    data
  })
}
// 新增投手
export function addPitcher(data = {}) {
  return request({
    url: `/sdLaunch/storeLauncher`,
    method: 'post',
    data
  })
}

// 投手组列表
export function getsdLaunchList(params = {}) {
  return request({
    url: `/sdLaunch/index`,
    method: 'get',
    params
  })
}

// 投手列表
export function getIndexLauncher(params = {}) {
  return request({
    url: `/sdLaunch/indexLauncher`,
    method: 'get',
    params
  })
}
// 渠道列表
export function getChannelList(params = {}) {
  return request({
    url: `/sdReportForm/channelsList`,
    method: 'get',
    params
  })
}
// 报表数据导出
export function exportList(data = {}) {
  return request({
    url: `/sdReportForm/export`,
    method: 'post',
    data
  })
}
